export default{
  "Video Compressor": "影片壓縮",
  "HitPaw Online Video Compressor": "HitPaw 線上影片壓縮",
  "Best video compressor tool to reduce video file size online without losing quality.": "最好的影片壓縮器工具，無損品質，線上壓縮影片檔案大小。",
  "Quality": "品質",
  "Small Size": "小尺寸（{{num}}%）",
  "High Quality": "高質量（{{num}}%）",
  "Frame Rate": "幀率",
  "Resolution": "解析度",
  "Keep Resolution": "保持原解析度",
  "Format": "格式",
  "Compress": "壓縮",
  "Compressing": "壓縮中",
  "Compress New": "壓縮新的（檔案）",
  "xx% reduction in size!": "減少了{{num}}%體積大小",
  "Compressed successfully, your file is now xxMB.": "壓縮成功，你的檔案現在<p>{{originalSize}}MB</p> <p>{{compressSize}}MB</p>",
  "Compression Failed": "壓縮失敗",
};